module.exports = __webpack_public_path__ + "87bf49be210e2c372e72cf7c06cc916f.svg";